import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useDate, useDateLimits, useScreen } from '../../../../../../hooks'
import { DateTimePicker } from '../../../../../DateTime'
import { FormikField } from '../../../../../Formik'
import {
  LISTING_FORM_FIELD_NAME_SCHEDULED_DEACTIVATE,
  LISTING_FORM_FIELD_NAME_SCHEDULED_GO_LIVE,
} from '../../../../../RentalPortalListing'

import * as styles from './ScheduleFields.module.css'

function ScheduleFields({ disabled }) {
  const { t } = useTranslation()

  const { maxDate } = useDateLimits()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen()

  const date = useDate()

  const {
    [LISTING_FORM_FIELD_NAME_SCHEDULED_DEACTIVATE]: deactivateValue,
    [LISTING_FORM_FIELD_NAME_SCHEDULED_GO_LIVE]: goLiveValue,
  } = values

  return (
    <>
      <FormikField
        Component={DateTimePicker}
        borderless={!isMobileScreenSize}
        dateProps={{
          placeholder: t(
            'RentalPortal.ListingFormGoLiveImmediatePlaceholderKey'
          ),
          wrapperClassName: styles.datePickerWrap,
        }}
        disabled={disabled}
        fieldComponentProps={{
          label: `${t('RentalPortal.ListingFormGoLiveLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        maxValue={deactivateValue ?? maxDate}
        minValue={date}
        name={LISTING_FORM_FIELD_NAME_SCHEDULED_GO_LIVE}
        timeProps={{
          placeholder: t('RentalPortal.ListingFormTimePlaceholderKey'),
          wrapperClassName: styles.timePickerWrap,
        }}
      />
      <FormikField
        Component={DateTimePicker}
        borderless={!isMobileScreenSize}
        dateProps={{
          placeholder: t('RentalPortal.ListingFormDatePlaceholderKey'),
          wrapperClassName: styles.datePickerWrap,
        }}
        disabled={disabled}
        fieldComponentProps={{
          label: `${t('RentalPortal.ListingFormDeactivateLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        maxValue={maxDate}
        minValue={goLiveValue ?? date}
        name={LISTING_FORM_FIELD_NAME_SCHEDULED_DEACTIVATE}
        timeProps={{
          placeholder: t('RentalPortal.ListingFormTimePlaceholderKey'),
          wrapperClassName: styles.timePickerWrap,
        }}
      />
    </>
  )
}

export default ScheduleFields
